export enum GTMEventName {
    ADD_TO_BAG = 'add_to_bag',
    REMOVE_PRODUCT_FROM_BAG = 'remove_product_from_bag',
    SEARCH = 'search',
    CLICK_SEARCH_SUGGESTION = 'click_search_suggestion',
    PWA_ERROR = 'pwa-error',
    START_CHECKOUT = 'startCheckout',
    ON_CONTINUE_TO_BILLING = 'on_continue_to_billing',
    COMPARE_PRODUCTS_PAGE_VIEW = 'compare_products_page_view',
    PDP_PAGE_VIEW = 'pdp_page_view',
    USER_REGISTRATION = 'user_registration',
    PLP_PAGE_VIEW = 'plp_page_view',
    CATEGORY_PAGE_VIEW = 'category_page_view',
    ORDER_PURCHASE = 'order_purchase',
}
